const previewOfTutkinnot = () => {
  return [
    {
      title: "Tutkintojen esikatselua ei ole vielä toteutettu."
    }
  ];
};

export default previewOfTutkinnot;
